import React from "react";
import { css } from "emotion";
import { defaultStyle } from "./styles";

export const ItemCardInfoCreditCard = ({}) => {
	return (
		<div
			className={css`
				${defaultStyle}
			`}
		>
			<p className="title">Por que precisamos dos dados do seu cartão?</p>
			<p>
				Para emitir passagens em companhias internacionais, o pagamento das taxas e encargos deve
				ser feito no cartão de crédito do mesmo titular das milhas.                 
			</p>

			<p>Por isso, cadastre os dados corretos do cartão.</p>

			<p>
				<strong>Sigilo e segurança dos seus dados</strong>
			</p>

			<p>
				Vale sempre lembrar que nossa plataforma é blindada e tem certificação de excelência em
				segurança. Aqui, seus dados estão protegidos.
			</p>
		</div>
	);
};
